/* eslint-disable no-unused-vars */
import { get, post, put, deleteApi, patch } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";

const { APIS } = API_ENDPOINTS;

export const getAllWorkFlowsService = () =>
  new Promise((resolve, reject) => {
    get(APIS.WORK_FLOW)
      .then(response => {
        resolve((response.Workflows && response.Workflows.DEAL) || {});
      })
      .catch(error => {
        reject(error);
      });
  });

export const createWorkFlowService = payload =>
  new Promise((resolve, reject) => {
    post(APIS.WORK_FLOW, payload)
      .then(response => {
        resolve(response.Workflow);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getWorkFlowDetailsService = id =>
  new Promise((resolve, reject) => {
    get(`${APIS.WORK_FLOW}/${id}`)
      .then(response => {
        resolve(response.Workflow);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateWorkFlowRuleService = (id, payload) =>
  new Promise((resolve, reject) => {
    put(`${APIS.WORK_FLOW}/${id}/rules`, payload)
      .then(response => {
        resolve(response.rules);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getWorkFlowAttributesService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.WORK_FLOW_CONDITIONS}/deal`)
      .then(response => {
        resolve(response.meta.attributes);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/WorkFlowActions/workFlowService.js